import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Prompt',
  sub: 'Task instructions, context & required output',
  primary: false
}, {
  icon: CpuIcon,
  label: 'AI Assistant',
  sub: 'ChatGPT, Claude, Gemini or similar',
  primary: true
}, {
  icon: FileCheck2Icon,
  label: 'Result',
  sub: 'A draft you review and adapt',
  primary: false
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="How a prompt works" data-id="element-289" data-mp="2po5mja1q6yov">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-290" data-mp="2zkidw19st0gg" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-60 ${n.primary ? 'border-teal/50 bg-teal/10' : 'border-line bg-ink-2'}`} data-id="element-291" data-mp="34j210504oiae">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.primary ? 'bg-teal text-ink' : 'bg-ink-3 text-gold'}`} data-id="element-292" data-mp="157iudx2arm3w">
              <n.icon className="h-5 w-5" aria-hidden="true" data-id="element-293" data-mp="1f08kcafrnj88" />
            </span>
            <div className="min-w-0" data-id="element-294" data-mp="1a90ajdaixvuj">
              <p className="font-display text-base font-bold uppercase text-fog" data-id="element-295" data-mp="1a7yyp6lop5br">{n.label}</p>
              <p className="text-xs leading-snug text-fog/60" data-id="element-296" data-mp="1595gx1zd6s5s">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 shrink-0 rotate-90 text-gold sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-297" data-mp="108rb7ql8juax" />}
        </React.Fragment>)}
    </div>;
}